import {
    useEffect,
    useState,
} from 'react';

import AdminLayout from './Components/AdminLayout';
import GalleryModal from './Components/GalleryModal';
import api from '../../api/api';
import { IMAGE_URL } from '../../path';

type GalleryItem = {
    id: number;
    image: string;
    link?: string;
};

export default function HomePageAdmin() {


    const [cuisineImage, setCuisineImage] =
        useState<File | null>(null);

    const [productImage, setProductImage] =
        useState<File | null>(null);

    const [cuisinePreview, setCuisinePreview] =
        useState('');

    const [productPreview, setProductPreview] =
        useState('');

    const [gallery, setGallery] =
        useState<GalleryItem[]>([]);

    const [
        showGalleryModal,
        setShowGalleryModal
    ] = useState(false);

    const [saving, setSaving] =
        useState(false);

    const [recipeDescription, setRecipeDescription] =
        useState('');

    const [rangeDescription, setRangeDescription] =
        useState('');

    const API_URL =
        IMAGE_URL;

    const getImageUrl = (
        path: string
    ) => {

        if (!path) {
            return '';
        }

        if (
            path.startsWith(
                'http'
            )
        ) {
            return path;
        }

        return `${API_URL}${path}`;
    };

    const loadPage = async () => {

        try {

            const response =
                await api.get(
                    '/home-page'
                );

            const data =
                response.data;

            setRecipeDescription(
                data.homePage?.recipe_description || ''
            );

            setRangeDescription(
                data.homePage?.range_description || ''
            );

            setGallery(

                (data.gallery || []).map(
                    (image: any) => ({

                        id:
                        image.id,

                        image:
                            getImageUrl(
                                image.image
                            ),

                        link:
                        image.link,

                    })
                )

            );

            if (
                data.homePage
                    ?.cook_by_cuisine_image
            ) {

                setCuisinePreview(
                    getImageUrl(
                        data.homePage
                            .cook_by_cuisine_image
                    )
                );
            }

            if (
                data.homePage
                    ?.cook_by_product_image
            ) {

                setProductPreview(
                    getImageUrl(
                        data.homePage
                            .cook_by_product_image
                    )
                );
            }

        } catch (error) {

            console.error(
                error
            );

        }
    };

    useEffect(() => {

        loadPage();

    }, []);

    const moveGalleryUp = (
        index: number
    ) => {

        if (
            index <= 0
        ) {
            return;
        }

        const updated =
            [...gallery];

        [
            updated[index - 1],
            updated[index]
        ] = [
            updated[index],
            updated[index - 1]
        ];

        setGallery(
            updated
        );
    };

    const moveGalleryDown = (
        index: number
    ) => {

        if (
            index >=
            gallery.length - 1
        ) {
            return;
        }

        const updated =
            [...gallery];

        [
            updated[index],
            updated[index + 1]
        ] = [
            updated[index + 1],
            updated[index]
        ];

        setGallery(
            updated
        );
    };

    const deleteGalleryImage = async (
        id: number
    ) => {

        if (
            !window.confirm(
                'Delete this image?'
            )
        ) {
            return;
        }

        try {

            await api.delete(
                `/home-page/gallery/${id}`
            );

            await loadPage();

        } catch (
            error
            ) {

            console.error(
                error
            );

        }
    };

    const handleAddGalleryImage = async (
        data: FormData
    ) => {

        try {

            await api.post(
                '/home-page/gallery',
                data
            );

            setShowGalleryModal(false);

            await loadPage();

        } catch (error) {

            console.error(error);

        }
    };

    const handleSave = async () => {

        try {

            setSaving(
                true
            );

            if (
                cuisineImage
            ) {

                const formData =
                    new FormData();

                formData.append(
                    'image',
                    cuisineImage
                );

                await api.post(
                    '/home-page/cuisine-image',
                    formData
                );
            }

            if (
                productImage
            ) {

                const formData =
                    new FormData();

                formData.append(
                    'image',
                    productImage
                );

                await api.post(
                    '/home-page/product-image',
                    formData
                );
            }

            await api.put(
                '/home-page/descriptions',
                {
                    recipe_description:
                    recipeDescription,

                    range_description:
                    rangeDescription,
                }
            );

            await api.post(
                '/home-page/gallery/reorder',
                {
                    gallery:
                        gallery.map(
                            (
                                image,
                                index
                            ) => ({

                                id:
                                image.id,

                                display_order:
                                    index + 1,

                            })
                        ),
                }
            );

            setCuisineImage(
                null
            );

            setProductImage(
                null
            );

            await loadPage();

            alert(
                'Home page updated successfully.'
            );

        } catch (
            error
            ) {

            console.error(
                error
            );

            alert(
                'Failed to save changes.'
            );

        } finally {

            setSaving(
                false
            );

        }
    };

    return (
        <AdminLayout>

            <div className="page-header">

                <h1>
                    Home Page
                </h1>

                <button
                    className="action-btn"
                    onClick={
                        handleSave
                    }
                    disabled={
                        saving
                    }
                >
                    {
                        saving
                            ? 'Saving...'
                            : 'Save Changes'
                    }
                </button>

            </div>

            <div className="admin-card">

                <div className="gallery-header">

                    <h2>
                        Banner Images
                    </h2>
                    <p className="field-hint">
                        Maximum file size: 2MB
                    </p>

                    <button
                        className="action-btn"
                        onClick={() =>
                            setShowGalleryModal(
                                true
                            )
                        }
                    >
                        Add Image
                    </button>

                    {/*
                    onChange={(e) => {

                        const files =
                            Array.from(
                                e.target.files ||
                                []
                            );

                        if (
                            !files.length
                        ) {
                            return;
                        }

                        const newImages =
                            files.map(
                                file => ({

                                    tempId:
                                        crypto.randomUUID(),

                                    image:
                                        URL.createObjectURL(
                                            file
                                        ),

                                    file,

                                    isNew:
                                        true,

                                })
                            );

                        setGallery(
                            prev => [
                                ...prev,
                                ...newImages
                            ]
                        );

                    }}
                /> */}

                </div>

                <div className="gallery-grid">

                    {gallery.map(
                        (
                            image,
                            index
                        ) => (

                            <div
                                key={
                                    image.id
                                }
                                className="gallery-item"
                            >

                                <div className="gallery-order">
                                    {index + 1}
                                </div>

                                <img
                                    src={
                                        image.image
                                    }
                                    alt=""
                                    className="gallery-image"
                                />

                                <div className="gallery-actions">

                                    <button
                                        type="button"
                                        className="action-btn"
                                        onClick={() =>
                                            moveGalleryUp(
                                                index
                                            )
                                        }
                                    >
                                        ▲
                                    </button>

                                    <button
                                        type="button"
                                        className="action-btn"
                                        onClick={() =>
                                            moveGalleryDown(
                                                index
                                            )
                                        }
                                    >
                                        ▼
                                    </button>

                                    <button
                                        type="button"
                                        className="delete-btn"
                                        onClick={() =>
                                            deleteGalleryImage(
                                                image.id
                                            )
                                        }
                                    >
                                        Delete
                                    </button>

                                </div>

                            </div>

                        )
                    )}

                </div>

            </div>

            <div className="cuisine-product-images">

                <div className="admin-card">

                    <h2>
                        Cook By Cuisine
                    </h2>
                    <p className="field-hint">
                        Maximum file size: 2MB
                    </p>

                    {cuisinePreview && (

                        <img
                            src={
                                cuisinePreview
                            }
                            alt=""
                            className="image-preview"
                        />

                    )}

                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {

                            const file =
                                e.target.files?.[0];

                            if (!file) {
                                return;
                            }

                            setCuisineImage(
                                file
                            );

                            setCuisinePreview(
                                URL.createObjectURL(
                                    file
                                )
                            );

                        }}
                    />

                </div>

                <div className="admin-card">

                    <h2>
                        Cook By Product
                    </h2>
                    <p className="field-hint">
                        Maximum file size: 2MB
                    </p>

                    {productPreview && (

                        <img
                            src={
                                productPreview
                            }
                            alt=""
                            className="image-preview"
                        />

                    )}

                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {

                            const file =
                                e.target.files?.[0];

                            if (!file) {
                                return;
                            }

                            setProductImage(
                                file
                            );

                            setProductPreview(
                                URL.createObjectURL(
                                    file
                                )
                            );

                        }}
                    />

                </div>

            </div>

            <div className="admin-card description">

                <label>
                    Recipe Description
                </label>

                <textarea
                    value={recipeDescription}
                    onChange={(e) =>
                        setRecipeDescription(
                            e.target.value
                        )
                    }
                    rows={6}
                    className="form-control"
                />

            </div>

            <div className="admin-card description">

                <label>
                    Range Description
                </label>

                <textarea
                    value={rangeDescription}
                    onChange={(e) =>
                        setRangeDescription(
                            e.target.value
                        )
                    }
                    rows={6}
                    className="form-control"
                />

            </div>

            {
                showGalleryModal && (
                    <GalleryModal
                        onClose={() => setShowGalleryModal(false)}
                        onSave={handleAddGalleryImage}
                    />
                )
            }

        </AdminLayout>
    );


}
